import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router';
import en from '../../../../lang/en-us';
import { getPaymentStatus } from '../../../../redux-store/actions/newPurchase';
import {
    PaymentStatusCodes,
    PaymentStatusResponse,
} from '../../../../redux-store/types/newPurchase';
import { EmandateRoutes } from '../emandate/routes';
import { EMandatePaths } from '../emandate/types';
import { CommercialRootPath } from '../routeConfig';
import { trackMyRequestPath } from '../utils';
const { dbCommercial } = en;

const FailedPaymentStatusCode = [
    PaymentStatusCodes.PAYMENT_NOT_ACCEPTED,
    PaymentStatusCodes.NOT_PROCESS,
    PaymentStatusCodes.BACKEND_ERROR,
    PaymentStatusCodes.MANDATE_REG_FAILED,
    PaymentStatusCodes.CANCELLED,
    PaymentStatusCodes.DECLINE_UPI,
];

const PendinyPaymentStatusCode = [
    PaymentStatusCodes.PENDING_FROM_BANK,
    PaymentStatusCodes.PENDING_FOR_PAYMENT,
    PaymentStatusCodes.MANDATE_PENDING,
];

type Props = {};

const MfSuccess: React.FunctionComponent<Props> = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const [paymentStatus, setPaymentStatus] = useState<PaymentStatusResponse | null>(null);

    useEffect(() => {
        if (!id) {
            history.push('/');
        }
        async function getStatus() {
            try {
                const response: any = await dispatch(getPaymentStatus({ reqId: id }));
                const { body } = response || {};
                setPaymentStatus(body);
            } catch (err: any) {
                alert(err.message);
                if (err.name == 422) {
                    history.push('/');
                }
            }
        }
        getStatus();
    }, []);

    const paymentType = history.location.pathname.includes(EMandatePaths.OtmStatus) ? 'OTM' : 'NP';

    if (!id || !paymentStatus) return null;
    const paymentFailed = FailedPaymentStatusCode.includes(Number(paymentStatus.statusCode));
    const paymentPending = PendinyPaymentStatusCode.includes(Number(paymentStatus.statusCode));
    return (
        <div className="curved-bg mf-success">
            <div
                className={`curved-bg-content nct-success-screen ${paymentFailed ? 'nct-failed-screen' : ''
                    }`}
            >
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <img
                            className="change-email-img"
                            src={
                                paymentFailed || paymentPending
                                    ? '/images/mf-failure-character.png'
                                    : '/images/mf-success-character.png'
                            }
                            alt="icon"
                        />
                        <h3 className="subheading">
                            {paymentFailed
                                ? dbCommercial.exploreMfs.failureScreen.heading
                                : paymentPending
                                    ? dbCommercial.exploreMfs.pendingScreen.heading
                                    : dbCommercial.exploreMfs.successScreen.heading}
                        </h3>
                        <p>
                            {`${paymentStatus?.status} with Req Id `}
                            <span>{id}</span>.
                        </p>
                    </div>
                    {/* <div className="curved-bg-content-inner-bottom">
                        <div className="mf-investment-summary">
                            <h4>{dbCommercial.exploreMfs.successScreen.investmentSummary}</h4>
                            <div className="mf-investment-summary-info">
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.scheme}</p>
                                    <h5>Nippon India Nifty Smallcap 250 Index Fund Reg Gr</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.panNo}</p>
                                    <h5>AVEOY9087K </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.folio}</p>
                                    <h5>23456123454</h5>
                                </div>
                            </div>
                            <div className="mf-investment-summary-info">
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.investmentType}</p>
                                    <h5>Lumpsum</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.investmentAmount}</p>
                                    <h5>₹ 5,000 </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.paymentMode}</p>
                                    <h5>Net Banking</h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.date}</p>
                                    <h5>27 Dec 2021, 12:30PM </h5>
                                </div>
                                <div className="mf-investment-summary-txt">
                                    <p>{dbCommercial.exploreMfs.successScreen.Id}</p>
                                    <h5>Trans-1234562611</h5>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="curved-bg-content-inner-bottom">
                        <Button
                            className="customBtn"
                            onClick={() =>
                                paymentType === 'NP'
                                    ? history.replace(trackMyRequestPath(id))
                                    : history.replace(
                                        `${CommercialRootPath}${EMandatePaths.OtmDetails}`,
                                    )
                            }
                        >
                            {paymentType === 'NP'
                                ? dbCommercial.exploreMfs.successScreen.goToTransact
                                : dbCommercial.exploreMfs.eMandate.gotoEmandate}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MfSuccess;
